import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useProfileDropdown } from "@hooks/useProfileDropdown";
import LanguageSwitcher from "@components/common/LanguageSwitcher";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useTranslation } from "react-i18next";
import ProfileModal from "@features/Profile/components";
import { UserModal } from "@components/common/Modal/UserModal";
import { LogoutConfirmationModal } from "@components/Auth";
import Button from "@components/common/Button/Button";

const ProfileDropdown = () => {
	const {
		showMenu,
		menuRef,
		handleToggle,
		handleLogout,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
		ShowProfile,
		HideProfile,
		showProfileModal,
	} = useProfileDropdown();
	const { t } = useTranslation();

	const ExpandIcon = showMenu ? (
		<ExpandLessIcon className="text-gray-400" />
	) : (
		<ExpandMoreIcon className="text-gray-400" />
	);

	return (
		<div className="relative">
			<Button onClick={handleToggle} variant="icon">
				{ExpandIcon}
			</Button>
			{showMenu && (
				<div
					ref={menuRef}
					className="absolute right-0 mt-6 w-56 bg-white rounded-xl shadow-xl border border-gray-200 z-50 p-4"
					role="menu"
					aria-label="Profile menu">
					<div
						className="flex items-center gap-2 mb-2 text-gray-900 font-medium cursor-pointer hover:bg-gray-100 p-2 rounded-lg"
						role="menuitem"
						onClick={ShowProfile}>
						<PersonOutlineOutlinedIcon color="info" sx={{ fontSize: "24px" }} />
						{t("psdaCommon.profile.profileTitle")}
					</div>
					<div className="h-[1px] bg-gray-200 my-2" role="separator" aria-orientation="horizontal" />
					<div className="mb-2">
						<LanguageSwitcher />
					</div>
					<div className="h-[1px] bg-gray-200 my-2" role="separator" aria-orientation="horizontal" />
					<button
						className="flex items-center gap-2 w-full px-3 py-2 rounded-lg bg-red-50 text-red-500 mt-2 hover:bg-red-100 transition"
						onClick={handleLogout}
						role="menuitem"
						type="button">
						<LogoutOutlinedIcon color="error" sx={{ fontSize: "2wpx" }} />
						{t("psdaCommon.common.buttons.logout")}
					</button>
				</div>
			)}
			{showProfileModal && (
				<UserModal
					heigth={100}
					width={35}
					show={showProfileModal}
					onClose={HideProfile}
					children={<ProfileModal HideProfile={HideProfile} />}
				/>
			)}
			<LogoutConfirmationModal show={showLogoutModal} onConfirm={handleLogoutConfirm} onCancel={handleLogoutCancel} />
		</div>
	);
};
export default ProfileDropdown;
